export default __webpack_public_path__ + "79856ce399cb305fafb894e6515009c8.svg";